module.exports = __webpack_public_path__ + "img/vector-light.2c27a541.svg";